module.exports = __webpack_public_path__ + "img/promotion-tooltip.f9bd6f2a.svg";